import React from 'react';
import { Enabler } from './Enabler';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { isTargetRoleId } from '../../utilities/roleUtility';
import { USER_ROLES } from '../../utilities/constants';

/**
 * @description 本社管理者専用Enabler
 */
const PrimeEnabler = props => (
  <Enabler
    enabled={isTargetRoleId(
      [USER_ROLES.prime],
      LocalStorageService.getRoleId()
    )}
  >
    {props.children}
  </Enabler>
);

export default PrimeEnabler;



// WEBPACK FOOTER //
// ./src/components/toggle/PrimeEnabler.jsx